import { gql, TypedDocumentNode } from "@apollo/client";

export const ACCOUNT_MFA_SETTINGS = gql`
  query AccountMFASettings {
    hasSSO
    enforceMFA
    securityKeys {
      id
      createdAt
      name
      owner
      currentOwner
    }
    viewer {
      id
      securityKeys {
        id
        createdAt
        name
        owner
      }
    }
  }
`;

type AccountToggleEnforcingMfaData = {
  accountToggleEnforcingMFA: boolean;
};

export const ACCOUNT_TOGGLE_ENFORCING_MFA: TypedDocumentNode<AccountToggleEnforcingMfaData> = gql`
  mutation AccountToggleEnforcingMFA {
    accountToggleEnforcingMFA
  }
`;
